module.exports = __webpack_public_path__ + "../resources/images/EmptyIllustration-c1bf49c43c40b275a1de765657894875.svg";